import React from 'react';
import { CTAButton } from './CTAButton';
import { Star, Shield, Zap } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-8 px-4 sm:px-6 bg-brand-rose text-white border-t-4 border-brand-gold text-center" data-id="element-46">
      <p className="text-xs font-button font-bold text-brand-gold uppercase tracking-widest mb-1.5" data-id="element-47">
        ONE LAST CHANCE
      </p>

      <p className="text-sm sm:text-base font-medium mb-4 leading-tight max-w-2xl mx-auto" data-id="element-48">
        Your students deserve the best version of you — not an exhausted one.
        <br data-id="element-49" />
        <br data-id="element-50" />
        Stop spending your Sundays planning from scratch. Stop second-guessing
        your class structure mid-session. Stop letting creative burnout steal
        your passion for dance.
        <br data-id="element-51" />
        <br data-id="element-52" />
        <span className="font-bold" data-id="element-53">
          Take back control of your teaching career with the professional tools
          you deserve.
        </span>
      </p>

      <div className="bg-white/10 border border-white/20 rounded-lg p-3 mb-4 shadow-md max-w-sm mx-auto" data-id="element-54">
        <p className="text-xs sm:text-sm font-bold mb-0.5 uppercase tracking-wide" data-id="element-55">
          Pack 6-in-1: Dance Ready™ + 5 Luxury Bonuses
        </p>
        <p className="text-base line-through opacity-70 mb-0.5" data-id="element-56">$97 USD</p>
        <p className="text-3xl font-heading font-bold text-brand-gold leading-none" data-id="element-57">
          Only: $27 USD
        </p>
      </div>

      <a href="https://danceready.impultienda.ar/checkout" className="block cursor-pointer mb-4" data-id="element-58">
        <img src="https://cdn.magicpatterns.com/uploads/vNhitVHkq5bJ6yeknhzbRq/ChatGPT-Image-14-jun-2026_-10_23_58-p.m..webp" alt="Dance Ready 6-in-1 Box Set" className="w-full max-w-[180px] mx-auto object-contain drop-shadow-xl" data-id="element-59" />
      </a>

      <div className="mb-3" data-id="element-60">
        <CTAButton href="https://danceready.impultienda.ar/checkout" className="!bg-brand-gold !text-brand-taupe border-none shadow-[0_4px_14px_0_rgba(212,175,55,0.39)] hover:shadow-[0_6px_20px_rgba(212,175,55,0.23)] hover:!bg-brand-gold/90" data-id="element-61">
          🚀 YES, I WANT MY DANCE READY™ PACK
        </CTAButton>
      </div>

      <div className="flex flex-col sm:flex-row justify-center items-center gap-1 sm:gap-4 text-[10px] sm:text-xs font-bold opacity-90" data-id="element-62">
        <div className="flex items-center gap-1" data-id="element-63">
          <Zap className="w-3.5 h-3.5 text-brand-gold" data-id="element-64" />
          <span data-id="element-65">Immediate Access — Delivered by Email</span>
        </div>
        <div className="flex items-center gap-1" data-id="element-66">
          <Star className="w-3.5 h-3.5 fill-brand-gold text-brand-gold" data-id="element-67" />
          <span data-id="element-68">4.9/5 — Verified Professional Reviews</span>
        </div>
        <div className="flex items-center gap-1" data-id="element-69">
          <Shield className="w-3.5 h-3.5 text-brand-gold" data-id="element-70" />
          <span data-id="element-71">7-Day Guarantee — Zero Risk</span>
        </div>
      </div>
    </section>;
}